const formatDatetime = (datetime) => {
  // Guard against null/undefined/empty and invalid dates to avoid 1 Jan 1970
  if (!datetime) return "";
  const d = new Date(datetime);
  if (isNaN(d.getTime())) return "";

  const now = new Date();

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const month = months[d.getMonth()];
  const date = d.getDate();
  const year = d.getFullYear();

  let fulldate = `${month} ${date}`;
  if (year !== now.getFullYear()) fulldate += `, ${year}`;

  // 24-hour format without locale issues
  const hours = d.getHours().toString().padStart(2, '0');
  const minutes = d.getMinutes().toString().padStart(2, '0');
  const time = `${hours}:${minutes}`;

  if (
    date === now.getDate() &&
    d.getMonth() === now.getMonth() &&
    year === now.getFullYear()
  ) return time;
  else if (
    date === now.getDate() - 1 &&
    d.getMonth() === now.getMonth() &&
    year === now.getFullYear()
  ) return "yesterday";
  else if (
    date === now.getDate() + 1 &&
    d.getMonth() === now.getMonth() &&
    year === now.getFullYear()
  ) return "tomorrow";
  else return fulldate;
};

export default formatDatetime;